interface ErrorCircleIconProps {
  size?: number;
}

export function ErrorCircleIcon({ size = 80 }: ErrorCircleIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 80 80" fill="none" aria-hidden="true">
      <circle cx="40" cy="40" r="36" stroke="var(--builders-color-error-200)" strokeWidth="3" />
      <line
        x1="26"
        y1="26"
        x2="54"
        y2="54"
        stroke="var(--builders-color-error-200)"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <line
        x1="54"
        y1="26"
        x2="26"
        y2="54"
        stroke="var(--builders-color-error-200)"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}
